import React from 'react'

import { useAssertContext } from '@hooks'

import type { SyncFiltersConfig } from '@components/filters/types'

const PageControllerContext = React.createContext<Nullable<SyncFiltersConfig>>(null)

interface PageControllerProviderProps {
  children: NonNullable<React.ReactNode> | NonNullable<React.ReactNode>[]
  value: SyncFiltersConfig
}

export function PageControllerProvider(props: PageControllerProviderProps) {
  return <PageControllerContext.Provider {...props} />
}

export function usePageConfig() {
  return useAssertContext(PageControllerContext)
}
